// Trello 581 X1: bounds for the OTP calls (submit a code / resend a code).
//
// Without a bound, the only limit on an OTP call was the generic 20s axios
// timeout in helpers/axios.js, so a backend that hangs left the user on the
// loader for 20s and then on a popup reading "timeout of 20000ms exceeded".
// The OTP endpoints are cheap (the code check is a DB read; the resend is a
// DB write + one mail, with the backend's own ConnectyCube calls capped at
// 2s/4s), so a call that has not answered after OTP_UPSTREAM_TIMEOUT_MS is
// dead, and the user is better served by the neutral "try again" popup.
//
// UPSTREAM — Next API route / business page -> backend (helpers/api.js).
export const OTP_UPSTREAM_TIMEOUT_MS = 12000;
// CLIENT — browser -> Next API route (helpers/internalRequest.js). Always
// longer than UPSTREAM so the route's own 5xx answer wins when it can, and the
// browser timeout is only the safety net for a hung route.
export const OTP_CLIENT_TIMEOUT_MS = 16000;
